module.exports = __webpack_public_path__ + "fonts/VetoSans-Light.d0950b5d.ttf";